module.exports = __webpack_public_path__ + "static/grafika6@2x-27e61bea841c76cfac51bcb56a9398cb.png";